var lib_core = require("lib-core");
var lib_geometry = require("lib-geometry");


var Camera2DModel = function (editor2DModel) {
    var self = this;
    lib_core.Model.call(this);

    this.editor2DModel = editor2DModel;

    // camera view
    // defines the coordinate system of the editor
    this.viewX = this.value("viewX", true); //defines the origin of the editor wrt. the origin of the canvas (see editor2d),
                                            //the value is defined in the units of the editor
    this.viewY = this.value("viewY", true);
    this.viewS = this.value("viewS", true); //defines the scaling factor of the editor coordinate system wrt. the canvas coordinate system
    //this.origin = this.value("origin", false);

    this.defaultWorkPlane = this.value("defaultWorkPlane", true);

    // initialisation
    this.viewX(0);
    this.viewY(0);
    this.viewS(1.0);

    // configurable constants
    this.viewSmin = 0.2;
    this.viewSmax = 10;

    //boundingbox of the visible part of the editor defined in the coordinate system of the editor
    this.workplane = this.shadow("workplane",
        function () {
            return self._getWorkplane();
        },
        null,
        [this.viewX, this.viewY, this.viewS, this.editor2DModel.canvasRect]
    );
};
lib_core.inherit(Camera2DModel, lib_core.Model);
lib_core.JsonParser.registerClass(Camera2DModel, "Camera2DModel");

module.exports = Camera2DModel;

Camera2DModel.prototype._getWorkplane = function() {
    var upper_left_orig = this.editor2DModel.canvasRect().getMinMin();
    var lower_right_orig = this.editor2DModel.canvasRect().getMaxMax();
    var diagonal = lower_right_orig.sub(upper_left_orig);

    var ps = new lib_geometry.PointSet([this.toRealCoord(lib_geometry.Coord.ORIGIN),
                                        this.toRealCoord(diagonal)]);
    var bb = ps.getBB();

    return bb;
};

/**
 * Converts a value from the canvas coordinate (see editor2d) system to the editor coordinate system
 * @return {Coord}
 */
Camera2DModel.prototype.toRealCoord = function(coord) {
    return new lib_geometry.Coord(coord.x/this.viewS()-this.viewX(),coord.y/-this.viewS()+this.viewY());
};

/**
 * Converts a value from the editor coordinate system to the canvas coordinate system
 * @return {Coord}
 */
Camera2DModel.prototype.toViewCoord = function(coord) {
    return new lib_geometry.Coord(this.viewS()*(coord.x+this.viewX()),this.viewS()*(coord.y+this.viewY()));
};

Camera2DModel.prototype.getBoundingBox = function() {
    // get all interactionModels that are currently loaded in this editor and
    // calculate the boundingBox for those
    var bbox = null;
    this.editor2DModel.interactionModelDataMap.forEach(function(data, IM) {
        var dataBbox = data.boundingBox ? data.boundingBox() : null;
        if(dataBbox) bbox = dataBbox.merge(bbox);
    });
    return bbox;
};
